import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the reportHome state domain
 */

const selectReportHomeDomain = (state) => state.get("reportHome", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoadingWidget = () =>
  createSelector(selectReportHomeDomain, (state) =>
    state.get("isLoadingWidget")
  )

export const makeSelectWidgetsData = () =>
  createSelector(selectReportHomeDomain, (state) => state.get("widgetsData"))

export const makeSelectHasOneDivisionAmbassador = () =>
  createSelector(selectReportHomeDomain, (state) =>
    state.get("hasOneDivisionAmbassador")
  )

export const makeSelectMetric = () =>
  createSelector(selectReportHomeDomain, (state) => state.get("metric"))

export const makeSelectIsLoadingDivisions = () =>
  createSelector(selectReportHomeDomain, (state) =>
    state.get("isLoadingDivisions")
  )

export const makeSelectDivisions = () =>
  createSelector(selectReportHomeDomain, (state) => state.get("divisions"))

export const makeSelectDivisionsAvailable = () =>
  createSelector(selectReportHomeDomain, (state) =>
    state.get("divisions_available")
  )

export const makeSelectDivisionsGeneral = () =>
  createSelector(selectReportHomeDomain, (state) =>
    state.get("divisions_general")
  )

export const makeSelectMeasureGeneral = () =>
  createSelector(selectReportHomeDomain, (state) =>
    state.get("measure_general")
  )

export const makeSelectDivisionsDrillDown = () =>
  createSelector(selectReportHomeDomain, (state) =>
    state.get("divisions_drilldown")
  )

export const makeSelectIsLoadingDimensions = () =>
  createSelector(selectReportHomeDomain, (state) =>
    state.get("isLoadingDimensions")
  )

export const makeSelectDimensions = () =>
  createSelector(selectReportHomeDomain, (state) => state.get("dimensions"))

export const makeSelectDimensionsDrillDown = () =>
  createSelector(selectReportHomeDomain, (state) =>
    state.get("dimensions_drilldown")
  )

/* Questions && Answers */

export const makeSelectIsLoadingQuestions = () =>
  createSelector(selectReportHomeDomain, (state) =>
    state.get("isLoadingQuestions")
  )

export const makeSelectIsLoadingMultipleChoiceQuestions = () =>
  createSelector(selectReportHomeDomain, (state) =>
    state.get("isLoadingMultipleChoiceQuestions")
  )

export const makeSelectMultipleChoiceQuestions = () =>
  createSelector(selectReportHomeDomain, (state) =>
    state.get("multipleChoiceQuestions")
  )

export const makeSelectQuestions = () =>
  createSelector(selectReportHomeDomain, (state) => state.get("questions"))

export const makeSelectNoProcess = () =>
  createSelector(selectReportHomeDomain, (state) => state.get("no_process"))

export const makeSelectIsLoadingTeams = () =>
  createSelector(selectReportHomeDomain, (state) => state.get("isLoadingTeams"))

export const makeSelectTeams = () =>
  createSelector(selectReportHomeDomain, (state) => state.get("teams"))

export const makeSelectTeamsDrillDown = () =>
  createSelector(selectReportHomeDomain, (state) =>
    state.get("teams_drilldown")
  )

export const makeSelectMeasureRangeColor = () =>
  createSelector(selectReportHomeDomain, (state) =>
    state.get("measureColorRange")
  )

export const makeSelectIsLoadingRanks = () =>
  createSelector(selectReportHomeDomain, (state) => state.get("isLoadingRanks"))

export const makeSelectRanks = () =>
  createSelector(selectReportHomeDomain, (state) => state.get("ranks"))
export const makeSelectIsDownloading = () =>
  createSelector(selectReportHomeDomain, (state) =>
    state.get("isDownloading")
  )
/**
 * Default selector used by ReportHome
 */

const makeSelectReportHome = () =>
  createSelector(selectReportHomeDomain, (substate) => substate.toJS())

export const makeSelectReportMeasureInfo = () =>
  createSelector(selectReportHomeDomain, (state) => state.get("measureInfo"))

export default makeSelectReportHome
export { selectReportHomeDomain }
